import React, { useMemo, useState } from 'react';
import { DndContext, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import { useStyletron } from 'styletron-react';
import SortableItem from './components/SortableItem';
import SortableOverlay from './components/SortableOverlay';
export function SortableList({
  items,
  onChange
}) {
  const [css] = useStyletron();
  const [active, setActive] = useState(null);
  const activeItem = useMemo(() => items.find(item => item.id === active?.id), [active, items]);
  const sensors = useSensors(useSensor(PointerSensor), useSensor(KeyboardSensor, {
    coordinateGetter: sortableKeyboardCoordinates
  }));
  return <DndContext sensors={sensors} onDragStart={({
    active
  }) => {
    setActive(active);
  }} onDragEnd={({
    active,
    over
  }) => {
    if (over && active.id !== over?.id) {
      const activeIndex = items.findIndex(({
        id
      }) => id === active.id);
      const overIndex = items.findIndex(({
        id
      }) => id === over.id);
      onChange(activeIndex, overIndex);
    }
    setActive(null);
  }} onDragCancel={() => {
    setActive(null);
  }}>
      <SortableContext items={items}>
        <ul className={css({
        paddingLeft: 0
      })} data-testid="drag-and-drop-list">
          {items.map(item => <React.Fragment key={item.id}>
              <SortableItem id={item.id}>{item.content}</SortableItem>
            </React.Fragment>)}
        </ul>
      </SortableContext>
      <SortableOverlay>
        {activeItem ? <SortableItem id={activeItem.id}>{activeItem.content}</SortableItem> : null}
      </SortableOverlay>
    </DndContext>;
}